import { useMantineTheme } from '@mantine/core';

import type { MantineSize } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';

export const useIsSize = (size: MantineSize) => {
  const theme = useMantineTheme();
  return useMediaQuery('(min-width: ' + theme.breakpoints[size] + 'px)');
};
